import { render, staticRenderFns } from "./live-broadcast-register.vue?vue&type=template&id=05e322bf&scoped=true&"
import script from "./live-broadcast-register.vue?vue&type=script&lang=js&"
export * from "./live-broadcast-register.vue?vue&type=script&lang=js&"
import style0 from "./live-broadcast-register.vue?vue&type=style&index=0&id=05e322bf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e322bf",
  null
  
)

export default component.exports